import { Component } from '@angular/core';
import {OrganizacionesComponent} from "./organizaciones/organizaciones.component";
import {CiudadanosComponent} from "./ciudadanos/ciudadanos.component";
import {NzTabComponent, NzTabDirective, NzTabSetComponent} from "ng-zorro-antd/tabs";
import {NzIconDirective} from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-directorio',
  imports: [
    OrganizacionesComponent,
    NzTabSetComponent,
    NzTabComponent,
    NzIconDirective
  ],
  templateUrl: './directorio.component.html',
  styleUrl: './directorio.component.css'
})
export class DirectorioComponent {

}
